import { Injectable, Output, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbsService {
  breadcrumbItems: {
    id: number;
    title: string;
    link: string;
    params: any;
  }[] = [];

  @Output() breadcrumbItemsEvent = new EventEmitter<any>();
  constructor() { }

  setBreadcrumbs(items) {
    this.breadcrumbItemsEvent.emit(items);
  }
}
